import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Applicant, BrokerList } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { KeyValue } from '../ApplicationDetails/contributor';
import { Gridstyles } from '../ApplicationDetails';
import { SubHeading } from '../investors/components';
import {
  checkValidationBasedOnDate,
  currencyConversion,
  getclIdField,
  getdpIdField,
  getIsServiceRequired,
  otherBrokerNamePresent,
  OthersOptionForRE,
  shouldShowRBICategory,
} from '../../utils/utilityFunctions';
import { investorTypeMasters, DLCLMasters, AOI_BOI_MASTER, gamblingValidationDate, servicesMaster } from '../../utils/constant';
import {
  YES_NO_BOOLEAN_MASTER,
  YES_NO_MASTER,
  REtypeMaster,
} from '../../utils/constant';
import { useDispatch } from 'react-redux';
import { getBrokers } from '../../redux-store/actions/application';
import { DematDeclarationPreview } from '../ApplicationDetails/kycDetails';
import { countryDeclaration } from '../declaration';
import { useFeatureToggles } from '../../utils/useDataMdms';

export default function ContributorDetails({
  applicants = [],
  ifXalt,
  createdAt,
}: {
  applicants: Partial<Applicant>[];
  ifXalt: boolean;
  createdAt?: string;
}): JSX.Element {
  const dispatch = useDispatch();
  const [brokerList, setBrokerList] = useState<BrokerList>();
  const { toggler } = useFeatureToggles();
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getBrokers())) as unknown as BrokerList;
        setBrokerList(response as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
            </Grid>
            {applicants.map((applicant) => {
              const isServicesRequired = getIsServiceRequired(applicant);
              return (
                <React.Fragment key={applicant.id}>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name Of Entity'} description={applicant.name} />
                      <KeyValue
                        title={'Date of Registration/Incorporation'}
                        description={formatShortDate(applicant.dateOfBirth)}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'Place of Registration/Incorporation'}
                        description={applicant.cityOfIncorporation}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'CKYC No./CKYC Acknowledge No./KIN No'}
                        description={applicant.ckycNo}
                      />
                      {applicant.investorType && (
                        <KeyValue
                          title={'Investor Type'}
                          description={investorTypeMasters[applicant.investorType]}
                        />
                      )}
                      {/* {ifXalt &&
                        investorTypeMasters[applicant?.investorType || ''] ===
                          investorTypeMasters.boi_or_aop && (
                          <KeyValue
                            title={'AOP or BOI'}
                            description={AOI_BOI_MASTER[applicant?.boiOrAop || '']}
                          />
                        )} */}
                      {checkValidationBasedOnDate(
                        createdAt || '',
                        toggler.dateFeatureToggles.reTypeValidationDate
                      ) && (
                        <>
                          <KeyValue
                            title={'RBI Regulated Entity'}
                            description={YES_NO_MASTER[applicant.rbiRegulatedEntity || '']}
                          />
                          {shouldShowRBICategory(applicant.rbiRegulatedEntity || '') && (
                            <>
                              <KeyValue
                                title={'RE Type'}
                                description={REtypeMaster[applicant.reType || '']}
                              />
                              {applicant.reType && (
                                <KeyValue
                                  title={'RBI Registration Number'}
                                  description={applicant.RBIRegNo}
                                />
                              )}
                              {OthersOptionForRE(applicant.reType || '') && (
                                <KeyValue
                                  title={'Other RE Type'}
                                  description={applicant.reTypeOthers}
                                />
                              )}
                            </>
                          )}
                        </>
                      )}
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      {checkValidationBasedOnDate(
                        createdAt||'',
                        toggler?.dateFeatureToggles?.borderCountryDeclarationDate || ''
                      ) && (
                        <KeyValue
                          title={countryDeclaration}
                          description={
                            YES_NO_BOOLEAN_MASTER[
                              applicant?.borderCountryDeclaration?.toString() || ''
                            ]
                          }
                        />
                      )}
                    </Grid>
                  </Gridstyles>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={21}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={applicant.grossAnnualIncome}
                      />
                      <KeyValue
                        title={'Net Worth'}
                        description={applicant.netWorth}
                        amount={applicant.netWorth ? currencyConversion(applicant.netWorth) : 0}
                      />
                      <KeyValue
                        title={'PEP Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      />
                      <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue title={'DP ID'} description={applicant.dpId} />
                      )}
                      {getclIdField(applicant.dlclId || '') && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name of Broker/Depository Participant (DP)'}
                          description={
                            otherBrokerNamePresent(applicant.nameOfBroker || '')
                              ? applicant.otherNameOfBroker
                              : brokerList?.broker_list.find(
                                  (broker) => broker.key === applicant.nameOfBroker
                                )?.value
                          }
                        />
                      )}
                      <DematDeclarationPreview applicant={applicant} />
                         {checkValidationBasedOnDate(createdAt || '', gamblingValidationDate) && (
                            <KeyValue
                              title="Non-Individual investors involved/providing any of the mentioned services:"
                              description={isServicesRequired
                                ?.map((key) => servicesMaster[key])
                                .join(', ')}
                            />)}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
